import React from 'react';

// import { useState } from 'react';
import { Box} from '@mui/material';
import { Container} from '@mui/material';
// import Grid from '@mui/material/Grid';
// import FormControl from '@mui/material/FormControl';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
// import Button from '@mui/material/Button';
// import Autocomplete from '@mui/material/Autocomplete';

import AddInspectingAgencyHQForm from '../Components/AddInspectingAgencyHQForm';
// import AddCompanyForm from '../../../Components/Companies/AddCompanyForm';

export default function AddInspectionAgencyPage() {

 
  return (
    <>
    
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Container>
        <AddInspectingAgencyHQForm/>
        {/* <AddCompanyForm
          addWhatCompanyTitle={"Inspection"}
          hqCompanyObject={companyObjct}
          handleNameChange={handleNameChange}
          handleEmailChange={handleEmailChange}
          handlePhoneChange={handlePhoneChange}
          handleAddressChange={handleAddressChange}
          handleAddressTwoChange={handleAddressTwoChange}
          handleCityChange={handleCityChange}
          handleStateChange={handleStateChange}
          handleZipChange={handleZipChange}
          submitNewHqCompany={submitNewHQInspection}
        /> */}
      </Container>
    </Box>
    </>
  )
}
